import { YStack, Text, Heading } from "tamagui";
import { tokens } from "tamagui-config";

type CircularProgressProps = {
  value: number;
  label: string;
  progressColor?: string;
};

export const CircularProgress = ({
  value,
  label,
  progressColor,
}: CircularProgressProps) => {
  const size = 160;
  const baseStrokeWidth = 4;
  const progressStrokeWidth = 6;
  const radius = (size - progressStrokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - value / 100);

  const backgroundStroke = tokens.color.transparentBorder;

  const circleId = Math.random();

  return (
    <YStack
      width={size}
      height="100%"
      alignItems="center"
      justifyContent="space-between"
    >
      <svg
        width={size}
        height={size}
        viewBox={`-10 -10 ${size + 20} ${size + 20}`}
      >
        <defs>
          <filter
            id={`blur-shadow-${circleId}`}
            x="-50%"
            y="-50%"
            width="200%"
            height="200%"
          >
            <feDropShadow
              dx="0"
              dy="0"
              stdDeviation="6"
              floodColor={progressColor}
              floodOpacity="0.5"
            />
          </filter>
        </defs>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={backgroundStroke}
          strokeWidth={baseStrokeWidth}
          fill="none"
        />

        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={progressColor}
          strokeWidth={progressStrokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          fill="none"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          filter={`url(#blur-shadow-${circleId})`}
        />
      </svg>

      <YStack
        position="absolute"
        top={size / 2 - 18}
        left={0}
        right={0}
        alignItems="center"
        justifyContent="center"
      >
        <Heading
          fontFamily="$body"
          fontWeight="$6"
          fontSize="$8.5"
          color={progressColor}
        >
          {value}%
        </Heading>
      </YStack>

      <Text
        fontFamily="$body"
        fontSize="$4.5"
        fontWeight="$4"
        color={tokens.color.textLight}
        marginTop="$5"
        textAlign="center"
      >
        {label}
      </Text>
    </YStack>
  );
};
